import React from 'react'
import {useAuth} from '../../auth'
import UseRoutesPermission from '../../../../_gori/hooks/UseRoutesPermission'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'
import {HazmatModal} from './HazmatModal'

const NoticeModals: React.FC = () => {
  const {currentUser} = useAuth()
  const {routes} = UseRoutesPermission()
  const {statesGlobal, setHazmat} = useStatesGlobal()

  if (!currentUser || routes.SYSTEM_ADMIN.hasPermission) return null

  if (statesGlobal.hazmat) {
    return <HazmatModal show={statesGlobal.hazmat} handleClose={() => setHazmat(false)} />
  }

  return null
}

export {NoticeModals}
